import { render, staticRenderFns } from "./PrfPackingRptIndex.vue?vue&type=template&id=1e0a1495"
import script from "./PrfPackingRptIndex.vue?vue&type=script&lang=js"
export * from "./PrfPackingRptIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports